export function getGetters(state) {
  return {
    visitsDetails: state.visitsDetails,
    patient: state.patient,
    showClosedOrInactive: state.showClosedOrInactive,
    unsavedVisitsMap: state.unsavedVisitsMap,
    isSavingActivities: state.isSavingActivities
  }
}